import { Injectable } from "@angular/core";
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { getDefaultLanguage } from "./languages";

@Injectable({ providedIn: 'root' })
export class LanguagesService {
  userLanguageCookieKey = 'user-lang';

  constructor(private cookie: SsrCookieService) { }

  getDefaultLanguage(): string {
    return getDefaultLanguage();
  }

  setUserLanguage(lang: string) {
    this.cookie.set(this.userLanguageCookieKey, lang, { path: '/', domain: this.getCookieDomain() });
  }

  getUserLanguage(): string {
    return this.cookie.get(this.userLanguageCookieKey);
  }

  getCookieDomain(): string {
    const domain = location?.hostname.split('.').slice(-2).join('.');
    return domain === 'localhost' ? domain : `.${domain}`;
  }
}
